import { IconProps } from './IconProps';

export const UpArrowRed_Trend = (props: IconProps) => {
  return (
    <svg
      className={props.className}
      style={props.style}
      width="25"
      height="25"
      viewBox="0 0 25 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11.559 3.43101L3.43753 11.5613C2.98479 12.0146 2.98519 12.749 3.43843 13.2018C3.65592 13.419 3.95077 13.5411 4.2582 13.5411L20.5012 13.5411C21.1418 13.5411 21.6611 13.0217 21.6611 12.3811C21.6611 12.0737 21.5391 11.7788 21.3218 11.5613L13.2003 3.43101C12.7476 2.97777 12.0123 2.97826 11.559 3.43101C11.5593 3.43071 11.5587 3.43131 11.559 3.43101ZM17.0415 13.5411L7.71786 13.5411L9.40562 19.4204C9.78641 20.7469 10.9996 21.6608 12.3797 21.6608C13.7597 21.6608 14.973 20.7469 15.3537 19.4204L17.0415 13.5411Z"
        fill="#FF0202"
      />
    </svg>
  );
};

